import { Bell, Search, ChevronDown } from 'lucide-react';
import { useAuthStore } from '../../stores/authStore';

const Header = () => {
  const { user } = useAuthStore();

  return (
    <header className="h-16 bg-white border-b border-neutral-200 flex items-center justify-between px-6">
      {/* Search */}
      <div className="flex-1 max-w-2xl">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-neutral-400" />
          <input
            type="text"
            placeholder="Search financial data, reports, models..."
            className="w-full pl-10 pr-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          />
        </div>
      </div>

      {/* Right section */}
      <div className="flex items-center space-x-4">
        {/* Notifications */}
        <button className="relative p-2 text-neutral-600 hover:bg-neutral-100 rounded-lg">
          <Bell className="w-5 h-5" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-alert-500 rounded-full"></span>
        </button>

        {/* User menu */}
        <div className="flex items-center space-x-2 px-3 py-2 hover:bg-neutral-100 rounded-lg cursor-pointer">
          <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
            <span className="text-primary-600 font-semibold text-sm">
              {user?.firstName?.[0]}{user?.lastName?.[0]}
            </span>
          </div>
          <ChevronDown className="w-4 h-4 text-neutral-600" />
        </div>
      </div>
    </header>
  );
};

export default Header;
